/**
 * True when the app is served on the play host (e.g. play.example.com), not the apex domain.
 */
export function isPlaySubdomain() {
  if (typeof window === 'undefined') return false;
  const host = window.location.hostname.toLowerCase();
  return host === 'play' || host.startsWith('play.');
}
